import { useQuery } from '@tanstack/react-query';
import { makeCRMApi } from '../CrmApi';
import { AxiosError, AxiosResponse } from 'axios';
import { ICrmActivityCategoryGroup } from '../types/CrmActivityTypes';

export const useCrmCategories = () => {
  const crmApi = makeCRMApi();

  const crmCategories = useQuery<AxiosResponse<ICrmActivityCategoryGroup[]>, AxiosError>({
    queryKey: ['crm-categories'],
    queryFn: () => {
      return crmApi.getCategories();
    },
    retry: false,
  });

  return {
    crmCategories,
  };
};
